/** App-owned storage keys use this prefix (auth, guest identity, check-in, etc.). */
export const APP_STORAGE_PREFIX = "ln_";

function collectPrefixedKeys(storage) {
  const keys = [];
  for (let i = 0; i < storage.length; i += 1) {
    const key = storage.key(i);
    if (key?.startsWith(APP_STORAGE_PREFIX)) keys.push(key);
  }
  return keys;
}

export function clearAppLocalStorage() {
  if (typeof window === "undefined") return;
  collectPrefixedKeys(localStorage).forEach((key) => localStorage.removeItem(key));
}

export function clearAppSessionStorage() {
  if (typeof window === "undefined") return;
  collectPrefixedKeys(sessionStorage).forEach((key) => sessionStorage.removeItem(key));
}

/** Drop all app-owned browser storage (local + session). */
export function clearAppStorage() {
  clearAppLocalStorage();
  clearAppSessionStorage();
}
